import { GridColDef } from '@mui/x-data-grid'
import CellStatus, { Color } from '@/components/GokuDataGrid/CellStatus'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { ResellerCustomer } from '@/modules/Reseller/types'
import { TFunction } from 'i18next'
import { Typogaphy } from 'vnetwork-ui'
import { IconButton, Tooltip } from '@mui/material'
import DeleteOutlineIcon from '@/icons/DeleteOutlineIcons'
import { Link } from 'react-router-dom'
import { generatePathDatacentral, paths } from '@/utils/path'

const CUSTOMER_STATUS_OPTIONS = (t: TFunction) => [
    {
        label: t('active'),
        value: 'active',
        color: 'success' as Color,
    },
    {
        label: t('inactive'),
        value: 'inactive',
        color: 'default' as Color,
    },
    {
        label: t('suspended'),
        value: 'suspended',
        color: 'error' as Color,
    },
]

export const columns = (
    t: TFunction,
    onRemove?: (customerId: number) => void
): GridColDef<ResellerCustomer>[] => [
    {
        field: 'customer_id',
        headerName: t('customer_id'),
        width: 100,
        sortable: false,
    },
    {
        field: 'customer_name',
        headerName: t('customer_name'),
        flex: 1,
        minWidth: 200,
        sortable: false,
        renderCell: ({ row }) => (
            <Link
                to={generatePathDatacentral(paths.customerDetail, {
                    id: row.customer_id.toString(),
                })}
                className="text-primary hover:underline"
            >
                {row.customer_name}
            </Link>
        ),
    },
    {
        field: 'customer_email',
        headerName: t('email'),
        flex: 1,
        minWidth: 200,
        sortable: false,
    },
    {
        field: 'status',
        headerName: t('status'),
        width: 120,
        sortable: false,
        renderCell: ({ row }) => {
            const status = CUSTOMER_STATUS_OPTIONS(t)?.find(
                (item) => item?.value === row.status
            )

            return (
                <CellStatus
                    label={status?.label || row.status || t('active')}
                    color={status?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            )
        },
    },
    {
        field: 'joined_at',
        headerName: t('joined_at'),
        width: 160,
        sortable: false,
        renderCell: ({ row }) =>
            row.joined_at ? (
                <CellDate date={row.joined_at} />
            ) : (
                <Typogaphy>-</Typogaphy>
            ),
    },
    {
        field: 'actions',
        headerName: t('actions'),
        width: 80,
        sortable: false,
        renderCell: ({ row }) => (
            <Tooltip title={t('remove')}>
                <IconButton
                    size="small"
                    color="error"
                    onClick={() => onRemove?.(row.customer_id)}
                >
                    <DeleteOutlineIcon />
                </IconButton>
            </Tooltip>
        ),
    },
]
